import { WEATHER_DETAIL_ICON_KEYS } from 'features/Weather/config/weatherDetailIcons.config';
import { formatTideEvent } from '../utils/tideTable.utils';

export const route = 'getTideTable';

export const tideForecastDetails = [
  {
    id: 'setOneHigh',
    label: 'Set One High',
    iconKey: WEATHER_DETAIL_ICON_KEYS.TIDE_HIGH,
    getValue: (forecast) => formatTideEvent(forecast?.tideSets?.[0]?.high, 'HIGH'),
  },
  {
    id: 'setOneLow',
    label: 'Set One Low',
    iconKey: WEATHER_DETAIL_ICON_KEYS.TIDE_LOW,
    getValue: (forecast) => formatTideEvent(forecast?.tideSets?.[0]?.low, 'LOW'),
  },
  {
    id: 'setTwoHigh',
    label: 'Set Two High',
    iconKey: WEATHER_DETAIL_ICON_KEYS.TIDE_HIGH,
    getValue: (forecast) => formatTideEvent(forecast?.tideSets?.[1]?.high, 'HIGH'),
  },
  {
    id: 'setTwoLow',
    label: 'Set Two Low',
    iconKey: WEATHER_DETAIL_ICON_KEYS.TIDE_LOW,
    getValue: (forecast) => formatTideEvent(forecast?.tideSets?.[1]?.low, 'LOW'),
  },
];
